import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: #1a1a1a;
  color: #fff;
  padding: 4rem 2rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
`;

const FooterSection = styled.div`
  h3 {
    font-family: 'Playfair Display', serif;
    color: #fff;
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }
`;

const FooterLink = styled(Link)`
  color: #ccc;
  text-decoration: none;
  display: block;
  margin-bottom: 0.8rem;
  transition: color 0.3s ease;

  &:hover {
    color: #4CAF50;
  }
`;

const ContactInfo = styled.div`
  p {
    color: #ccc;
    margin-bottom: 0.8rem;
    line-height: 1.6;
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #333;
  color: #ccc;
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>Quick Links</h3>
          <FooterLink to="/">Home</FooterLink>
          <FooterLink to="/projects">Projects</FooterLink>
          <FooterLink to="/gallery">Gallery</FooterLink>
          <FooterLink to="/about">About Us</FooterLink>
          <FooterLink to="/services">Services</FooterLink>
          <FooterLink to="/contact">Contact</FooterLink>
          <FooterLink to="/admin/login">Admin Login</FooterLink>
        </FooterSection>

        <FooterSection>
          <h3>Services</h3>
          <FooterLink to="/services">GSM Installation</FooterLink>
          <FooterLink to="/services">Power Systems</FooterLink>
          <FooterLink to="/services">IT Infrastructure</FooterLink>
          <FooterLink to="/services">Solar Installation</FooterLink>
        </FooterSection>

        <FooterSection>
          <h3>Contact Us</h3>
          <ContactInfo>
            <p>1&2 Police Academy,<br />Paynesville Monrovia, Liberia</p>
            <p>Phone:<br />+231-887290859<br />+231773986529</p>
            <p>Email:<br />info@sunbold.org</p>
          </ContactInfo>
        </FooterSection>
      </FooterContent>
      
      <Copyright>
        &copy; {currentYear} Sunbold. All rights reserved.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
